import { createSlice } from '@reduxjs/toolkit';
import { getGlobalCheckpoints } from './globalCheckpointsAction';

export const globalCheckpointsSlice = createSlice({
  name: 'globalCheckpoints',
  initialState: {
    loading: false,
    data: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGlobalCheckpoints.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getGlobalCheckpoints.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.error = null;
    });
    builder.addCase(getGlobalCheckpoints.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
